import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'ORBRO triển khai thông tin tòa nhà và thông tin trong nhà một cách đổi mới nhằm cải thiện công tác quản lý và quy hoạch tòa nhà. Để làm được điều này, ORBRO số hóa kết cấu kiến trúc và cơ sở hạ tầng, đồng thời thông qua nhiều loại thông tin khác nhau, cung cấp những thông tin cốt lõi cần thiết cho thiết kế kiến trúc, quản lý cơ sở vật chất và giám sát an toàn.',
  keywords: 'Bản sao số, tòa nhà số, thành phố số, thực tế ảo, ban sao so, toa nha so, thanh pho so, thuc te ao.',
  ogSite: 'Digital Twin - Xây dựng thông tin tòa nhà và thông tin trong nhà',
  title: 'Digital Twin - Xây dựng thông tin tòa nhà và thông tin trong nhà',
  ogUrl: 'https://orbro.io/vi/blog/digitaltwin-buildings',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDmsHKPo0k1JGpYe5RqcLPvhvPsttOE54okj7zmGDmBsNO7w1O-JK1oTjUeN0SXoXeuVHVRR0yqY597xyclhreNiwqO8zxMhslWsAccGNFJL7Cc4jphNGY1U-ApF8rYUJlkQ29hCvXhs1-kJ7ItJ8yzqul6tD2bkCeeSf24qL0tmKPNG7wJdcdkE8HnxTJ-dAJvm-HQ1tD8-RFPjUfTcllJI-RCb7dzd6jATNYzQbe1GQD7gejTG574T2T6jKa1sIQLT1me2evIreAszenpfb2ZOAOafbrlQEnfJCF577BDuUZxdtYW-PpTWZdcoK_GlrZTVEXWFVIe4zYY4BA9uI-4MvLCytQ19heux-zPZ2uj0Pd-eu04szV3P6TFIG2dqGtdzui7sXRbRh4-9toRM1UEYley9vu4sOHPbxuwV1LN97GHKbtKrmz4OsgOS0jK8VWR0v_KCwr08MXIduU_b2QT5axXUH4CSftoADRRfaDprmZIqjdAdy7RqILvmsg_V7NQAcd9xapuxx4MMoC42nj2n0iwd9yZV--15jzcgqW6daHUiYEZ4ggt7Uy2LoPScqjh7hhOm8vT1XPj6fSf3W1SgBduBXU9h5e0_bG9GKZLWMCy72SHi0Xs0NO0X7FSOgdDU0scaP-F8WlOsTezavpMEhxUlz2fhL_mBIfZVO25KKS-y-Qfuul0bpf2coLNtuVO4yW_hZEZuAzW7FbuIUdoyI04V7I493a1IXz6-A_ZcTH2j2retDHu_nD6RnBrnlcCsY0tnVCMM0ho0k_GLGaGTrs_88IPxii47Y_Qa1XXH-8-wwpGN0UocvGhXB6rdM7S-m7_MIT3ONC4MyvE3Bqjkid-QLeYtThJ2zXLCXfCIaCyi4jttco-MJjx84qBVRrUWpwcvpISJ7E9pYCJukWT1rgVNPsgO1baez2jR2IyH1hMZ4SXB6nHNVoylyuvAjn1uYfjDCfOgRlqmcK8wt3U1GImqc68KthjcbhAjDNmlLNtBl9Pd4Ksg0Xts8R_Z_LbV6Ue834BoCmu5H_jzmEevCkvwPsYoLsmqebwEqmrp2B58f2e32e0YY8L8jPuMPX3UDZyxX98adUK-gekxc1YB5JrqJPlcC4nZA-XLh8EmakSbt83hYYjIkhbHeafd7Hr5M-Em9znV_sFo2DaAwfkAQRoa80pNidI39UxDJVdey6nVP9H6UPL-i_N-H1K6LpiALIwQNKPMlI4up5e-hme40ZgUL9QKbBaKDyfOxk1aqml1cTzHCZJRP_jLw2dOoS1K-EG7OsGJDxmnclokA0StmKuFCPLAbAodPa1K_Btbk2GtITh4kvm07TLOp_LDZBnztDlzA8WuId3bEWiXNRc5qKlfv5UYlEn_k4L03K4A-T49R-Pi75Jp53wW68HhGwDoSbyYjaiI8plzJeyMyGJduXJZtYWh66ETIXdt8IxUDYw5otbzXD-lFsSLdM09U37NH_lU0c07Sjg77a4m1OfI1-mfJmHzqzvn9kksa3H2aYES0HhIq5RPgdd0NyW7b2IvL9b7nDE4tL4D-hf70biexJ_aaBkb=w1923-h1074',
  ogType: 'website',
  date: '2023-12-26',
  tag1: '#Bansaoso',
  tag2: '#Toanhaso',
  tag3: '#Thanhphoso',
  tag4: '#Thucteao',
  text: [
    {
      head: 'Digital Twin - Xây dựng thông tin tòa nhà và thông tin trong nhà',
      subHead: '',
      desc: 'ORBRO triển khai thông tin tòa nhà và thông tin trong nhà một cách đổi mới nhằm cải thiện công tác quản lý và quy hoạch tòa nhà. Để làm được điều này, ORBRO số hóa kết cấu kiến trúc và cơ sở hạ tầng, đồng thời thông qua nhiều loại thông tin khác nhau, cung cấp những thông tin cốt lõi cần thiết cho thiết kế kiến trúc, quản lý cơ sở vật chất và giám sát an toàn.\nThông qua hình ảnh độ phân giải cao và mô hình 3D, ORBRO thể hiện chi tiết các đặc điểm cấu trúc và ngoại thất của tòa nhà, trong khi bản đồ trong nhà trực quan hóa chính xác sơ đồ bố trí bên trong tòa nhà. Những thông tin này giúp hiểu rõ ràng về cấu trúc và biểu diễn trực quan của tòa nhà.\nNgoài ra, việc biểu diễn thông tin cơ sở hạ tầng trong tòa nhà, kiểm tra trạng thái thiết bị theo thời gian thực, và tích hợp thiết bị bên ngoài đóng vai trò quan trọng trong quản lý tòa nhà, bảo trì và tự động hóa. Thông qua đó, có thể kiểm tra và quản lý hiệu quả dữ liệu cần thiết cho vận hành và quản lý tòa nhà theo thời gian thực.',
      dot: '',
    },
    {
      head: 'Thể hiện đồ họa chi tiết của công trình',
      subHead: '',
      desc: 'ORBRO sử dụng hình ảnh độ phân giải cao và công nghệ mô hình 3D tiên tiến để thể hiện chi tiết các đặc điểm cấu trúc và ngoại thất của tòa nhà. Điều này đóng vai trò quan trọng giúp các kiến trúc sư, kỹ sư và nhà quy hoạch đô thị đánh giá thiết kế và tính năng của tòa nhà.',
      dot: '',
    },
    {
      head: 'Thể hiện bản đồ trong nhà',
      subHead: '',
      desc: 'ORBRO trực quan hóa chính xác sơ đồ bố trí bên trong tòa nhà nhằm tối đa hóa hiệu quả sử dụng không gian trong nhà, đồng thời cung cấp thông tin thiết yếu cho việc lập kế hoạch an toàn và thoát hiểm.',
      dot: '',
    },
    {
      head: 'Thể hiện thông tin về hạ tầng bên trong tòa nhà',
      subHead: '',
      desc: 'ORBRO số hóa các cơ sở hạ tầng quan trọng bên trong tòa nhà như hệ thống HVAC, hệ thống điện và đường ống nước, cung cấp thông tin thiết yếu cho việc quản lý và bảo trì tòa nhà.',
      dot: '',
    },
    {
      head: 'Kiểm tra trạng thái thiết bị theo thời gian thực',
      subHead: '',
      desc: 'Thông qua việc giám sát theo thời gian thực các thiết bị và hệ thống trong tòa nhà, ORBRO nhanh chóng phát hiện sự suy giảm hiệu suất hoặc hỏng hóc của thiết bị và tiến hành bảo trì ngay lập tức.',
      dot: '',
    },
    {
      head: 'Tích hợp thiết bị bên ngoài',
      subHead: '',
      desc: 'ORBRO giúp hệ thống quản lý tòa nhà trở nên thông minh và tự động hơn thông qua việc tích hợp với công nghệ thông minh và các thiết bị IoT.',
      dot: '',
    },
    {
      head: 'Hỗ trợ doanh nghiệp, trung tâm nhà phát triển',
      subHead: '',
      desc: 'ORBRO giới thiệu các giải pháp đổi mới cho việc quản lý và vận hành tòa nhà bằng cách hỗ trợ các nhà phát triển truy cập dữ liệu liên quan đến tòa nhà và phát triển các ứng dụng tùy chỉnh.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
